import Hour from './Hour';

const Hours = ({ data, dataOriginName }) => {
    
    const hours = data.hourly.map((hour, index) =>
        <Hour key={hour.hour_unix} hourData={hour} index={index} dataOriginName={dataOriginName} />
    )

    return (
        <div className="hours__container">
            {hours}
        </div>
    )
}

export default Hours;
